import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import CheckInimg from "../../../images/CheckInimg.png";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Card,
  Navbar,
} from "react-bootstrap";
import axios from "../../util/Axios/AxiosInstance.js"
import "./UsersManagement.css";
import { useForm } from "react-hook-form";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import AOS from "aos";
import { useNavigate } from "react-router-dom";
import "aos/dist/aos.css";

function UsersManagement({HandleEvent}) {
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);
  const [branch, setBranch] = useState(localStorage.getItem("branch"));
  const [branchId, setBranchId] = useState(localStorage.getItem("branchId"));
  const [emailId, setEmailId] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [role, setRole] = useState("");
  const [contractName, setContractName] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [error, setError] = useState("");
  const [roleList, setRoleList] = useState([{id: "", role: ""},]);
  const [vendorList, setVendorList] = useState([{id: "", vendorName: "", contractName: ""},]);
  const [vendorAccount, setVendorAccount] = useState(false);

  // const errorCheck = async (e) => {
  //   if (
  //       contractName.trim().length == 0 ||
  //       vendorName.trim().length == 0 ||
  //       contractorAge <= 20 ||
  //       contractorAge >= 70 ||
  //       (gender != "male" && gender != "female") ||
  //       address.trim().length == 0 ||
  //       pinCode.length != 6 ||
  //       contactNumber.length != 10 ||
  //       altNumber === contactNumber ||
  //       email.length == 0 ||
  //       altEmail === email ||
  //       sac.trim().length <= 0 ||
  //       esi.trim().length == 0 ||
  //       pfEstablishmentNumber.trim().length == 0 ||
  //       gstNumber.trim().length == 0 ||
  //       bankState.trim().length == 0 ||
  //       bankName.trim().length == 0 ||
  //       accountNumber.length < 5 ||
  //       accountNumber.length > 15 ||
  //       ifscCode.trim().length == 0 ||
  //       branchName.trim().length == 0 ||
  //       contractSupervisorName.trim().length == 0 ||
  //       !supervisorContactNo.match("[0-9]") ||
  //       supervisorContactNo.length != 10 ||
  //       supervisorEmail.trim().length <= 0
  //   ) {
  //     setError(true);
  //     window.scrollTo({
  //       top: 0,
  //       behavior: "smooth",
  //     });
  //   } else {
  //     handleClickConfirm(e);
  //   }
  // };

  // const handleClickConfirm = (e) => {
  //   confirmAlert({
  //     title: <p className="alertTitle">Confirm to submit</p>,
  //     message: (
  //         <p className="alertMessage">
  //           Click on Proceed to Save the Vendor Details
  //         </p>
  //     ),
  //     buttons: [
  //       {
  //         label: "Proceed",
  //         onClick: () => handleSubmitForm(e),
  //       },
  //       {
  //         label: "Cancel",
  //       },
  //     ],
  //   });
  // };

  // const sucessMessage = () => {
  //   confirmAlert({
  //     title: <p className="alertTitle">Updated Successfully</p>,
  //     message: <img src={CheckInimg} className="successImg" alt="" />,
  //     buttons: [
  //       {
  //         label: "Close Page",
  //       },
  //     ],
  //   });
  //   HandleEvent(1);
  // };

  // const handleSubmitForm = async (e) => {
  //   e.preventDefault();
  //   try {
  //     let res = await fetch(API_URL + "addVendorMasterDetails", {
  //       method: "post",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         branchId: branchId,
  //         contractName: contractName,
  //         vendorName: vendorName,
  //         vendorDob: vendorDob,
  //         contractorAge: contractorAge,
  //         gender: gender,
  //         address: address,
  //         pinCode: pinCode,
  //         contactNumber: contactNumber,
  //         altNumber: altNumber,
  //         email: email,
  //         altEmail: altEmail,
  //         sac: sac,
  //         esi: esi,
  //         pfEstablishmentNumber: pfEstablishmentNumber,
  //         gstNumber: gstNumber,
  //         bankState: bankState,
  //         bankName: bankName,
  //         accountNumber: accountNumber,
  //         ifscCode: ifscCode,
  //         branchName: branchName,
  //         contractSupervisorName: contractSupervisorName,
  //         supervisorContactNo: supervisorContactNo,
  //         supervisorEmail: supervisorEmail,
  //       }),
  //     });
  //     let resJson = await res.json();
  //     if (res.status === 200) {
  //       sucessMessage();
  //       setShowMsgV(true);
  //     } else {

  //     }
  //   } catch (err) {

  //   }
  // };


  const getUserRolesByBranchId = async (branchId) => {
    try {
        const data = await axios.get(
            "getUserRolesByBranchId/" + branchId
        );
        setRoleList(data.data);
    } catch (e) {}
};

const getVendorDetailsByBranchId = async (branchId) => {
  try {
      const data = await axios.get(
          "getVendorMasterDetailsByBranchId/" + branchId
      );
      setVendorList(data.data);
  } catch (e) {}
};

const getVendorDetails = (e) => {

};

const updateRole = (e) => {
  setRole(e.target.value);
  if(e.target.value == 'Vendor'){
    setVendorAccount(true);
  }
  else{
    setVendorAccount(false);
    setVendorId("");
    setVendorName("");
  }
};

  useEffect(() => {
    getUserRolesByBranchId(branchId);
    AOS.init();
  }, [])

  useEffect(() => {
    if(role == 'Vendor'){
      setVendorAccount(true);
      getVendorDetailsByBranchId(branchId);
    }
  },[role])

  return (
      <div >
        <Container fluid className="px-0">
        <div>
        <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Manage Users</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>

          <Col>
          <Row>
          <Form.Label column md={6} lg={6} sm={6} xl={6}>Role</Form.Label>
          <Col><Form.Select onChange={(e) => updateRole(e)}>
            <option key={"defaultOption"} value={"defaultOption"}>Select Role</option>
            {roleList.map(ListRole => (
                            <option
                              key={ListRole.id}
                              value={ListRole.role}
                              id={ListRole.role}
                            >
                              {ListRole.role}
                            </option>
                          ))}
                        </Form.Select>
                        {error&& (role == "defaultOption")?
                        <label className="requiredValidation">Please Select Role </label>:""}
                        </Col>
                        </Row>
                        </Col>

          <Col>
          <Row>
          <Form.Label hidden= {!vendorAccount} column md={6} lg={6} sm={6} xl={6}>Vendor</Form.Label>
          <Col><Form.Select hidden= {!vendorAccount} onChange={(e) => getVendorDetails(e)}>
            <option key={"defaultOption"} value={"defaultOption"}>Select Vendor</option>
            {vendorList.map(vendorDetails => (
                            <option
                              key={vendorDetails.id}
                              value={vendorDetails.vendorName}
                              id={vendorDetails.contractName}
                            >
                              {vendorDetails.vendorName}
                            </option>
                          ))}
                        </Form.Select>
                        {error&& (vendorName == "defaultOption") && vendorAccount == true?
                        <label className="requiredValidation">Please Select Vendor </label>:""}
          </Col>
          </Row>
          </Col>

          <Form.Label>Username</Form.Label>
          <Form.Control type="text" placeholder="Enter here.." autoFocus
          onChange={(e) => setUserName(e.target.value)} value={userName}
                            />
                            {error && userName.trim().length <= 0 ? (
                                <label className="requiredValidation">
                                  Username Can't be empty
                                </label>
                            ) : (
                                ""
                            )}

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="name@example.com"
                onChange={(e) => setEmailId(e.target.value)} value={emailId}
              />
            </Form.Group>
            {error && emailId.trim().length <= 0 ?
            (<label className="requiredValidation"> Email Can't be Empty</label>) : (" ")}

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="password"
                onChange={(e) => setPassword(e.target.value)} value={password}
              />
            </Form.Group>
            {error && password.trim().length <= 0 ?
            (<label className="requiredValidation"> Password Can't be Empty</label>) : (" ")}

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="password"
                onChange={(e) => setConfirmPassword(e.target.value)} value={confirmPassword}
              />
            </Form.Group>
            {error && confirmPassword.trim().length <= 0 ?
            (<label className="requiredValidation"> Can't be Empty </label>) : (" ")}
            {error && confirmPassword.trim().length !== password ?
            (<label className="requiredValidation"> Not Matching with the Password </label>) : (" ")}


          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      </div>
      </Container>
      </div>
  );
}

export default UsersManagement;
